import { createStyles } from "antd-style";
import { modalPrefixCls } from "@/base/index";

export const useModalTrackingViewStyles = createStyles(({ css }: any) => ({
  modal: css`
    .${modalPrefixCls}-content {
      min-height: 250px;
    }
  `,
  content: css``,
  contentImage: css``,
  loader: css`
    position: absolute;
    inset: 0;
    margin: auto;
  `,
}));
